import { render } from "./UserSettingsPage.vue?vue&type=template&id=1a34d2c3&ts=true"
import script from "./UserSettingsPage.vue?vue&type=script&lang=ts"
export * from "./UserSettingsPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__